import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter = () => {
    return (
        <div className="layout-footer">
            {/* Mobile Footer */}
            <div className="flex md:hidden flex-column align-items-center w-full px-3 py-3 text-center">
                {/* Links Row - Wrap on small screens */}
                <div className="flex flex-wrap justify-content-center align-items-center gap-2 mb-2">
                    <Link to="/app/company/about" className="text-600 hover:text-primary transition-colors transition-duration-150 text-xs">
                        About
                    </Link>
                    <span className="text-300">•</span>
                    <Link to="/app/legal/privacy" className="text-600 hover:text-primary transition-colors transition-duration-150 text-xs">
                        Privacy
                    </Link>
                    <span className="text-300">•</span>
                    <Link to="/app/legal/terms" className="text-600 hover:text-primary transition-colors transition-duration-150 text-xs">
                        Terms
                    </Link>
                    <span className="text-300">•</span>
                    <Link to="/app/legal/refund" className="text-600 hover:text-primary transition-colors transition-duration-150 text-xs">
                        Refund
                    </Link>
                    <span className="text-300">•</span>
                    <Link to="/app/support/contact" className="text-600 hover:text-primary transition-colors transition-duration-150 text-xs">
                        Contact
                    </Link>
                </div>

                {/* Copyright Row */}
                <div className="flex align-items-center justify-content-center gap-1">
                    <span className="text-xs text-600">© 2026</span>
                    <img src={`${process.env.PUBLIC_URL}/layout/images/interestng_logo_updated.jpeg`} alt="INTERESTNG" height="16" style={{width: 'auto', mixBlendMode: 'multiply', filter: 'contrast(1.1) brightness(1.05)'}} />
                    <span className="text-xs text-600">All Rights Reserved</span>
                </div>
            </div>

            {/* Desktop Footer */}
            <div className="hidden md:flex justify-content-between align-items-center w-full px-6 py-4">
                <div className="flex align-items-center gap-2">
                    <span className="text-sm text-600">© 2026</span>
                    <img src={`${process.env.PUBLIC_URL}/layout/images/interestng_logo_updated.jpeg`} alt="INTERESTNG" height="20" style={{width: 'auto', mixBlendMode: 'multiply', filter: 'contrast(1.1) brightness(1.05)'}} />
                    <span className="text-sm text-600">- All Rights Reserved</span>
                </div>
                
                <div className="flex align-items-center">
                    <Link to="/app/company/about" className="text-600 hover:text-primary transition-colors transition-duration-150 mx-3 text-sm font-medium">
                        About Us
                    </Link>
                    <span className="text-300 mx-2">•</span>
                    <Link to="/app/legal/privacy" className="text-600 hover:text-primary transition-colors transition-duration-150 mx-3 text-sm font-medium">
                        Privacy Policy
                    </Link>
                    <span className="text-300 mx-2">•</span>
                    <Link to="/app/legal/terms" className="text-600 hover:text-primary transition-colors transition-duration-150 mx-3 text-sm font-medium">
                        Terms & Conditions
                    </Link>
                    <span className="text-300 mx-2">•</span>
                    <Link to="/app/legal/refund" className="text-600 hover:text-primary transition-colors transition-duration-150 mx-3 text-sm font-medium">
                        Refund Policy
                    </Link>
                    <span className="text-300 mx-2">•</span>
                    <Link to="/app/support/contact" className="text-600 hover:text-primary transition-colors transition-duration-150 mx-3 text-sm font-medium">
                        Contact
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AppFooter;